import * as _4 from 'lodash4';
import { Comment, CommentMeta, CourseComment, PlanComment, SlotComment } from '../builders/comment_builder';
export class CommentServant {
  static isCourseComment(comment: Comment & CommentMeta): comment is CourseComment & CommentMeta {
    return comment.content_type === 'cat.Course';
  }

  static isSlotComment(comment: Comment & CommentMeta): comment is SlotComment & CommentMeta {
    return comment.content_type === 'academicplan.Programslot';
  }

  static isPlanComment(comment: Comment & CommentMeta): comment is PlanComment & CommentMeta {
    return comment.content_type === null;
  }

  static getValidCourseComments(_comments: Array<CourseComment & CommentMeta>) {
    return _4.toArray(_comments).filter(CommentServant.isCourseComment);
  }

  static groupCommentsBasedOnType(comments: Array<Comment & CommentMeta>) {
    return comments.reduce((queryResultSet, comment) => {
      if (CommentServant.isPlanComment(comment)) {
        queryResultSet[comment.id] = comment;
      } else {
        queryResultSet[comment.object_id] = comment;
      }
      return queryResultSet;
    }, {} as Record<string, (CourseComment & CommentMeta) | (PlanComment & CommentMeta) | (SlotComment & CommentMeta)>);
  }

  static getHoverTemplate(comment: Comment & CommentMeta) {
    return `
        <div class="mtl"></div>
        <div class='text'>"${comment.message}"</div>
        <div class='text ptm text-sz-s'>${comment.sender_info.first_name} ${
      comment.sender_info.last_name
    } sent on ${comment._updated_ts.format('DD MMM, YYYY')}</div>
      `;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/comments/servants/comment_servant.ts